import React from 'react';
import { Page, BText } from '../../../components';
import { Button, ButtonContainer } from '../../../components/Form';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { increaseCount, decreaseCount, updateColor, clearDemo } from '../../../store/demo/demoActions';

export const DemoRedux = () => {
  const dispatch = useAppDispatch();
  const rtDemo = useAppSelector(s => s.demo);

  return (
    <Page title={'Demo - Redux'} style={{ backgroundColor: rtDemo.color }}>
      <BText>Click the buttons below to trigger redux update</BText>

      <BText>Count: {rtDemo.count}</BText>
      <ButtonContainer direction="horizontal">
        <Button onPress={() => dispatch(decreaseCount())}>- Count</Button>
        <Button onPress={() => dispatch(increaseCount())}>+ Count</Button>
      </ButtonContainer>

      <ButtonContainer direction="horizontal">
        <Button onPress={() => dispatch(updateColor('yellow'))}>Yellow</Button>
        <Button onPress={() => dispatch(updateColor('red'))}>Red</Button>
      </ButtonContainer>
      <Button onPress={() => dispatch(clearDemo())}>Reset</Button>
    </Page>
  );
};
